/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pageMiner.vue?vue&type=template&id=66bec59c"
import script from "./pageMiner.vue?vue&type=script&lang=js"
export * from "./pageMiner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports